module.exports = __webpack_public_path__ + "img/details-head__mark.svg?1d51690006d411e50dc6206230774af6";